import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RequestInProgressGuard } from '../../guards/request-in-progress/request-in-progress.guard';
import { SessionGuard } from '../../guards/session/session.guard';
import { MainRoutes } from './../../guards/guard.models';
import { MainRequestsListComponent } from './../../shared/main-requests-list/main-requests-list.component';
import { LandAndBuildingRegisterDataUpdateRequestComponent } from './land-and-building-register-data-update-request.component';
import { LBRDURNewDataUpdateRequestComponent } from './new-data-update-request/new-data-update-request.component';

const landAndBuildingRegisterDataUpdateRequestRoutes: Routes = [
  {
    path: MainRoutes.LandAndBuildingRegisterDataUpdateRequest,
    component: LandAndBuildingRegisterDataUpdateRequestComponent,
    canActivate: [SessionGuard],
    children: [
      {
        path: '',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
      {
        path: 'new-request',
        component: LBRDURNewDataUpdateRequestComponent,
        canDeactivate: [RequestInProgressGuard],
      },
      {
        path: 'requests-list',
        component: MainRequestsListComponent,
      },
      {
        path: '**',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(landAndBuildingRegisterDataUpdateRequestRoutes),
  ],
  providers: [SessionGuard, RequestInProgressGuard],
  exports: [RouterModule],
})
export class LandAndBuildingRegisterDataUpdateRequestRoutingModule {}
